/** Décide si une réponse API doit effacer le téléphone et renvoyer à la connexion.

Une session révoquée ou un compte désactivé répond 401 sur un appel fait avec
le jeton agent. On ne purge pas :
- un 401 de mot de passe actuel incorrect (`/api/auth/password`) ;
- un 401 de connexion (`/api/auth/login`) ;
- un 403 « changement de mot de passe requis » ou un refus de brouillon ;
- un 401 d'une route admin (jeton X-Admin-Token).
*/
export function shouldPurgeAgentSession(status, url, flags = {}) {
  if (!flags.hadAgentToken || flags.hadAdminToken) return false;
  if (status !== 401) return false;
  const path = String(url || '');
  if (path.includes('/api/auth/password') || path.includes('/api/auth/login')) return false;
  if (path.includes('/api/admin/')) return false;
  return true;
}
